import React from 'react';
import './SellerTrustSummary.css';

const SellerTrustSummary = ({ trust, compact = false }) => {
    if (!trust) return null;
    const ratingVal = trust.averageRating ?? trust.AverageRating ?? 0;
    const stars = '★'.repeat(Math.round(ratingVal));
    const empty = '☆'.repeat(5 - Math.round(ratingVal));
    const reviewCount = trust.reviewCount ?? trust.ReviewCount ?? 0;
    const sold = trust.itemsSoldCount ?? trust.ItemsSoldCount ?? 0;
    const username = trust.username ?? trust.Username ?? 'Seller';
    const joined = trust.dateJoinedFormatted ?? trust.DateJoinedFormatted ?? '';

    if (compact) {
        return (
            <div className="seller-trust-compact">
                <span className="seller-name">{username}</span>
                <span className="seller-rating">{stars}{empty} ({reviewCount})</span>
            </div>
        );
    }

    return (
        <div className="seller-trust-card">
            <div className="seller-trust-header">
                <strong>{username}</strong>
                <span className="seller-stars">{stars}{empty}</span>
            </div>
            <p className="seller-meta">
                {ratingVal > 0 ? `${Number(ratingVal).toFixed(1)} · ` : ''}
                {reviewCount} review{reviewCount !== 1 ? 's' : ''} · {sold} sold
                {joined ? ` · Joined ${joined}` : ''}
            </p>
        </div>
    );
};

export default SellerTrustSummary;
